import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../../../../App.css';
import "../../../../assets/css/bookingtruckschedule.css";
// import "../../assets/css/bookingtruckschedule.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faPlus, faChevronLeft, faChevronRight, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import Header from "../../../../Components/Header/Header";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ExportGrid from './ExportGrid.js';
import ImportGrid from './ImportGrid.js';
// import ExportActive from '../bookingTruck/ExportActive';
// import ExportTrash from '../bookingTruck/ExportTrash';
import TopMenu from "../../../../Components/TopMenu/TopMenu";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
// import Button from 'react-bootstrap/Button';
import { Modal, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {Form, Dropdown, Row, Col} from 'react-bootstrap';
import Autosuggest from 'react-autosuggest';
import Arcv from "../../../../assets/images/archive.svg";
import Trash from "../../../../assets/images/delete.svg";
import Export from "../../../../assets/images/export.svg";
import Exportw from "../../../../assets/images/exportw.png";
import AddStation from '../../../../Components/common/AddStation';
import AddStationAddress from '../../../../Components/common/AddStationAddress';
import Select from 'react-select';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { STATIONGRID, BOOKINGTRUCKGRID, ADDTRUCKSCHEDULE } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';


// const initialSuggestion = JSON.parse(localStorage.getItem('stationData')) || [];
// const initialSuggestions = initialSuggestion.Active || [];

const BookingtruckSchedule = () => {

    const childRef = useRef();

    const [exportGrid, setExportGrid] = useState();

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {

    //             const res = await withRFSToken.post(BOOKINGTRUCKGRID, {})
    //                 .then(function (res) {
    //                     const innerData = res.data.response_data;
    //                     // console.log("🚀 ~ .then ~ innerData:", innerData)
    //                     setExportGrid(innerData.export);
    //                 });

    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //         }
    //     };
    //     // Call the fetchData function to fetch data from the API
    //     fetchData();

    // }, []);

    const [boardPoint, setBoardPoint] = useState([]);
    const [boardPointAddress, setBoardPointAddress] = useState([]);
    const [selectedBoardPointAddress, setSelectedBoardPointAddress] = useState([]);
    const [offPoint, setOffPoint] = useState([]);
    const [offPointAddress, setOffPointAddress] = useState([]);
    const [selectedOffPointAddress, setSelectedOffPointAddress] = useState([]);


    const [value, setValue] = useState('');
    const [valueOffpoint, setValueOffpoint] = useState('');
    const [showAddButton, setShowAddButton] = useState(false);
    const [showAddButtonOffpoint, setShowAddButtonOffpoint] = useState(false);
    const [selectedBoardpoint, setSelectedBoardpoint] = useState(null);
    const [selectedOffpointId, setSelectedOffpointId] = useState(null);

    // useEffect(() => {
    //     if (apigridData) {
    //         const activeData = apigridData.Active;
    //         console.log("🚀 ~ useEffect ~ activeData:", activeData)
    //         setSuggestionsBp(activeData);
    //         setSuggestionsOffpoint(activeData);
    //     }
    //   }, [apigridData]);
    //   console.log("🚀 ~ BookingtruckSchedule ~ suggestionsBp", suggestionsBp)
    const [fetchStation, setFetchStation] = useState([]);
    // useEffect(() => {
    const fetchData = async () => {
        try {
            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const activeInnerData = res.data.response_data.Active;
                    const transformedData = activeInnerData ? activeInnerData.map(item => ({
                        // id: item.id,
                        value: item.id,
                        label: item.station_code,
                        address: item.station_addresses,
                    })) : []; // For multiselect
                    //   console.log("🚀 ~ transformedData ~ transformedData:", transformedData)
                    setBoardPoint(transformedData); // For multiselect
                    setOffPoint(transformedData);
                    setFetchStation(innerData.Active);
                    // setSuggestionsBp(innerData.Active);
                    // setSuggestionsOffpoint(innerData.Active);
                    return activeInnerData
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // Call the fetchData function to fetch data from the API
    // fetchData();

    // }, []);
    // console.log("🚀 ~ .then ~ setSuggestionsBp:", suggestionsBp)

    const [formData, setFormData] = useState({
        booking_type: '',
        bookingtruck_no: '',
        boardpoint: '',
        boardpoint_address: '',
        offpoint: '',
        offpoint_address: '',
        trip_type: 'O',
        date: '',
        time: '',
        selected_days: [],
        freq_date: '',
        freq_time: '',
        start_date: '',
        end_date: ''
    })

    const [stationData, setStationData] = useState({});
    const [addressType, setAddressType] = useState('');
    const handleReloadAddress = async () => {
        console.log('prop1');
        try {
            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const activeInnerData = res.data.response_data.Active;
                    // console.log("🚀 ~ activeInnerData:", activeInnerData)
                    const transformedData = activeInnerData ? activeInnerData.map(item => ({
                        id: item.id,
                        value: item.id,
                        label: item.station_code,
                        address: item.station_addresses,
                    })) : []; // For multiselect
                    setBoardPoint(transformedData); // For multiselect
                    setOffPoint(transformedData)
                    if (selectedBoardpoint !== null) { }
                    setFetchStation(innerData.Active);
                    // setSuggestionsBp(innerData.Active);
                    // setSuggestionsOffpoint(innerData.Active);
                    if (addressType == 'bp') {
                        // console.log('address Type', addressType);
                        if (innerData) {
                            const station = innerData.Active.find(station => station.id === stationData.value)
                            // console.log('station~~',station);
                            if (station.station_addresses) {
                                setBoardPointAddress(station ? station.station_addresses.map(handler => ({
                                    value: handler.id,
                                    label: `${handler.handler_name} - ${handler.address_1}`
                                })) : []);
                                // setBpaddress(station.station_addresses);
                            } else {
                                // setBpaddress([]);
                            }
                        } else {
                            // setBpaddress([]);
                        }
                    } else {
                        // console.log('address Type', addressType);
                        if (innerData) {
                            const station = innerData.Active.find(station => station.id === stationData.value)
                            if (station.station_addresses) {
                                setOffPointAddress(station ? station.station_addresses.map(handler => ({
                                    value: handler.id,
                                    label: `${handler.handler_name} - ${handler.address_1}`
                                })) : []);
                                // setSelectedOffpoint(station.station_addresses);
                            } else {
                                // setSelectedOffpoint([]);
                            }
                        } else {
                            // setSelectedOffpoint([]);
                        }
                    }

                    setShowAddStation(false);
                    setShowAddStationAddress(false);
                    return activeInnerData
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // const stationAddress = suggestionsBp.find(station => getSuggestionValue(station).toLowerCase() === fetchStation.station_code.toLowerCase());
    }
    // useEffect(() =>{
    //     handleReloadAddress();
    // }, [])
    // const onChange = (event, { newValue }) => {
    //     // console.log('567', newValue);
    //     setValue(newValue);

    //     if (!newValue) {
    //         // setBpaddress(null);
    //     } else {
    //         // Filter suggestionsBp based on the input value
    //         // const station = suggestionsBp.find(station => getSuggestionValue(station).toLowerCase() === newValue.toLowerCase());
    //         // If a matching station is found, set bpaddress to its station_addresses data
    //         if (station) {
    //             console.log('567', station);
    //             setBpaddress(station.station_addresses);
    //         } else {
    //             setBpaddress(null); // Set bpaddress to null if no matching station is found
    //         }
    //     }

    // };

    // const onSuggestionsClearRequested = () => {
    //     setSuggestionsBp([]);
    //     setSelectedOffpoint(null); // TO CLEAN FIRST FIELD

    // };

    // const getSuggestionValue = (suggestion) => suggestion.station_code;

    // const renderSuggestion = (suggestion) => <div>{suggestion.station_code}</div>;
    // const onSelectBpaddress = (bpadd) => {
    //     // console.log("🚀 ~ onSelectBpaddress ~ 777:", bpadd)

    //     // const addressOptions = bpadd.station_addresses.map(address => (
    //     //     `${address.handler_name} - ${address.address_1}`
    //     // ));
    //     // setBpaddress(addressOptions);
    //     // if (bpadd) { setBpaddress(bpadd.station_addresses);} comment 30.04.24
    //     if (bpadd) {
    //         if (bpadd.station_addresses) {
    //             setBpaddress(bpadd.station_addresses);
    //         } else {
    //             setBpaddress([]);
    //         }
    //     } else {
    //         setBpaddress([]);
    //     }

    //     setFormData({
    //         ...formData,
    //         boardpoint: bpadd.id
    //     });
    // }

    // const inputProps = {
    //     placeholder: 'Type a Stations',
    //     value,
    //     onChange: onChange,
    // };
    // console.log("🚀 ~ BookingtruckSchedule ~ inputProps:", inputProps)


    // const onSelectOffpoint = (offpoint) => {
    //     // console.log("🚀 ~ onSelectOffpoint ~ offpoint:", offpoint)
    //     // const addressOptions = offpoint.station_addresses.map(address => (
    //     //     `${address.handler_name} - ${address.address_1}`
    //     // ));
    //     // setSelectedOffpoint(addressOptions);
    //     if (offpoint) { setSelectedOffpoint(offpoint.station_addresses); }

    //     setFormData({
    //         ...formData,
    //         offpoint: offpoint.id
    //     });
    // };

    // const inputOffpointProps = {
    //   placeholder: 'Type a X',
    //   valueOffpoint,
    //   onChange: onChangeOffpoint,
    // };

    // ++++++++++++++++ Autosuggest End ++++++++++++++++++++++

    const [showAddStation, setShowAddStation] = useState(false)
    const onAddButtonClick = (autosuggestId) => {
        // AddStation
        console.log("Add button clicked", autosuggestId);
        // setShowAddButton(true);
        setShowAddButton(false);
        setShowAddButtonOffpoint(false);
        setShowAddStation(true);
        console.log(showAddStation);
        if (autosuggestId == 'op') {
            setValueOffpoint('');
        } else {
            setValue('');
        }


    };
    const handleCloseModal = () => {
        setShowAddButton(false);
        setShowAddStation(false);
        setShowAddStationAddress(false);
        // setFormData({
        //     ...formData,
        //     station: {},
        // });
    };


    const [showAddStationAddress, setShowAddStationAddress] = useState(false)
    const handleAddAddressClick = (addressType, stationId) => {
        console.log('M55', addressType, stationId);
        if (!stationId) {
            if (addressType == 'bp') {
                toast.error('Please select Boardpoint')
            } else {
                toast.error('Please select Offpoint')
            }
        } else {
            setStationData(stationId);
            setShowAddStationAddress(true);
            setAddressType(addressType);
        }

        // handleReloadAddress(addressType);
    }

    const handleFormOnchange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
        // console.log("🚀 ~ handleFormOnchange ~ formData:", updatedData);
        // console.log("🚀 ~ handleFormOnchange ~ formData:159", formData)
    }
    // Validation
    const validateFormData = () => {
        let isValid = true;
        // if (!formData.booking_type) {
        //     console.log('Text input is required');
        //     toast.error('Please set Booking Type');
        //     isValid = false;
        // } 
        if (!formData.bookingtruck_no) {
            console.log('Text input is required');
            toast.error('Bookingtruck Number must not be blank');
            isValid = false;
        } else if (!formData.boardpoint) {
            console.log('Text input is required');
            toast.error('Boardpoint must not be blank');
            isValid = false;
        } else if (!formData.boardpoint_address) {
            console.log('Text input is required');
            toast.error('Boardpoint Address must not be blank');
            isValid = false;
        } else if (!formData.offpoint) {
            console.log('Text input is required');
            toast.error('Offpoint must not be blank');
            isValid = false;
        } else if (!formData.offpoint_address) {
            console.log('Text input is required');
            toast.error('Offpoint Address must not be blank');
            isValid = false;
        } else if (formData.trip_type == 'O') {
            if (!formData.departure_date_time) {
                console.log('Text input is required');
                toast.error('Departure Date Time must not be blank');
                isValid = false;
            } else if (!formData.arrival_date_time) {
                console.log('Text input is required');
                toast.error('Arrival Date Time must not be blank');
                isValid = false;
            }
            else {
                return isValid;
            }
        } else if (formData.trip_type == 'F') {
            if (!formData.selected_days) {
                console.log('Text input is required');
                toast.error('Please Select Days');
                isValid = false;
            } else if (!formData.start_date) {
                console.log('Text input is required');
                toast.error('Start Date must not be blank');
                isValid = false;
            } else if (!formData.end_date) {
                console.log('Text input is required');
                toast.error('End Date must not be blank');
                isValid = false;
            } else if (!formData.travel_time) {
                console.log('Text input is required');
                toast.error('Date must not be blank');
                isValid = false;
            }
            else {
                return isValid;
            }
        }
        else {
            return isValid;
        }
    };
    const handleAddBookingtruck = async () => {
        // Here you can access all the form data from the formData state variable
        console.log('160', formData);
        // dispatch(addBookingTruckData(formData));
        if (validateFormData()) {
            try {
                const res = await withRFSToken.post(ADDTRUCKSCHEDULE, formData);
                // .then(function (res) {
                // const innerData = res;
                // console.log("🚀 ~ .then ~ innerData:", innerData)
                if (res.data.response_code == 200) {
                    setExportGrid(formData);
                    setShow(false);
                    // onSuggestionsClearRequested();

                    setFormData({
                        booking_type: '',
                        bookingtruck_no: '',
                        boardpoint: '',
                        boardpoint_address: '',
                        offpoint: '',
                        offpoint_address: '',
                        trip_type: 'O',
                        date: '',
                        time: '',
                        selected_days: [],
                        freq_date: '',
                        freq_time: '',
                        start_date: '',
                        end_date: ''
                    });
                    setBoardPointAddress([]);
                    setOffPointAddress([]);
                } else {
                    toast.error(res.data.response_msg);
                }
                // });

            } catch (error) {
                console.error('Error sending request:', error);
            }

        }
        // You can perform any further actions with the form data here
    };

    const handleEdit = async (data) => {
        console.log("🚀 ~ handleEdit ~ data:", data)
        // Here you can handle the edit logic
        setShow(true);
        let fetchstations = [];
        try {
            const res = await withRFSToken.post(STATIONGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const activeInnerData = res.data.response_data.Active;
                    fetchstations = innerData.Active;
                    setFetchStation(innerData.Active);
                    const transformedData = activeInnerData ? activeInnerData.map(item => ({
                        // id: item.id,
                        value: item.id,
                        label: item.station_code,
                        address: item.station_addresses,
                    })) : []; // For multiselect
                    setBoardPoint(transformedData); // For multiselect
                    setOffPoint(transformedData)
                    // setSuggestionsBp(innerData.Active);
                    // setSuggestionsOffpoint(innerData.Active);
                    return activeInnerData
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }

        const station = fetchstations.find(station => station.station_code === data.boardpoint);
        setBoardPointAddress(station ? station.station_addresses.map(handler => ({
            value: handler.id,
            label: `${handler.handler_name} - ${handler.address_1}`
        })) : []);
        const bpAddress = station?.station_addresses.find(stadd => stadd.id === data.boardpoint_address)
        // console.log("🚀 ~ handleEdit ~ stations:", fetchstations)
        // const stationAddress = station.station_addresses.find(address => address.station_code === data.boardpoint_address);
        const stationOp = fetchstations.find(station => station.station_code === data.offpoint);
        setOffPointAddress(stationOp ? stationOp.station_addresses.map(handler => ({
            value: handler.id,
            label: `${handler.handler_name} - ${handler.address_1}`
        })) : []);
        console.log("🚀 ~ handleEdit ~ station:XXX", station)

        if (data) {
            setValue(data.boardpoint); // Set the input value to the station code
            // setBpaddress(station.station_addresses);
            // onSelectBpaddress(station);

            setValueOffpoint(data.offpoint);
            // onSelectOffpoint(stationOp)
            // setSelectedValueBpaddress(data.boardpoint_address);
        } else {
            setValue('');
            // setBpaddress([]);
        }

        const transformData = {
            add_edit: 'E',
            booking_type: data.booking_type,
            bookingtruck_id: data.bookingtruck_id,
            bookingtruck_no: data.bookingtruck_no,
            boardpoint: station.id,
            boardpoint_address: bpAddress?.id || null,
            offpoint: stationOp.id,
            offpoint_address: data.offpoint_address,
            trip_type: data.trip_type,
            date: data.date,
            time: data.time,
            selected_days: data.selected_days,
            freq_date: data.freq_date,
            freq_time: data.freq_time,
            start_date: data.start_date,
            end_date: data.end_date,
            departure_time: data.departure_time,
            travel_time: data.arrival_time
        }
        console.log('Data to edit:', data);
        setFormData(transformData);
        // Perform your edit operation, like making an API call to update the data
    };

    // const reloadGrid = async () => {
    //     try {
    //         const res = await withRFSToken.post(BOOKINGTRUCKGRID, {})
    //             .then(function (res) {
    //                 const innerData = res.data.response_data;
    //                 // console.log("🚀 ~ .then ~ innerData:", innerData)
    //                 setExportGrid(innerData.export);
    //             });

    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    // ++++++++++++++++ Autosuggest End ++++++++++++++++++++++

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setFormData({
            booking_type: '',
            bookingtruck_no: '',
            boardpoint: '',
            boardpoint_address: '',
            offpoint: '',
            offpoint_address: '',
            trip_type: 'O',
            date: '',
            time: '',
            selected_days: [],
            freq_date: '',
            freq_time: '',
            start_date: '',
            end_date: ''
        });
        setBoardPointAddress([]);
        setOffPointAddress([]);
        setFrequentBooking('O');
        setSelected([]);
        // setValueOffpoint('');
        // setValue('');
        // setShowAddAddressButton(false);
        // setShowAddAddressButton2(false);
        // setShowAddButton(false);
        setShow(false)
    };
    const handleShow = () => { setShow(true); fetchData(); };

    const [selectedButton, setSelectedButton] = useState('export');
    const handleButtonClick = (button) => {
        setSelectedButton(button);
    };

    // Frequency function Section Start
    const [frequentBooking, setFrequentBooking] = useState('O');
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // const updatedData = { ...frequentBooking, [name]: value };
        const updatedData = e.target.value;
        setFrequentBooking(updatedData);
        setFormData({
            ...formData,
            trip_type: updatedData
        });
    };
    // frequency Function End

    const [selected, setSelected] = useState([]);

    const handleClick = (day) => {
        if (selected.includes(day)) {
            setSelected(selected.filter((d) => d !== day));
        } else {
            setSelected([...selected, day]);
        }
        const selectedDays = formData.selected_days.includes(day) ? formData.selected_days.filter(item => item !== day) : [...formData.selected_days, day];
        setFormData({
            ...formData,
            selected_days: selectedDays
        });
    };

    //   +++++++++++++++++++++++++++++ Frequent select
    // Tabs Start
    const [trashGridLoaded, setTrashGridLoaded] = useState(false);

    const handleTabSelect = (selectedTabKey) => {
        if (selectedTabKey === 'trash' && !trashGridLoaded) {
            setTrashGridLoaded(true);
        }
    };
    // Tabs End

    const [time, setTime] = useState(0);

    // const handleTimeChange = (e) => {
    //     let input = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characte
    //     // Limit input length to 4 characters (HHMM format)
    //     if (input.length > 4) input = input.slice(0, 4
    //     // If input has 3 or more digits, insert a colon automatically
    //     if (input.length >= 2) {
    //         const hours = input.slice(0, 2); // Get first two digits as hours
    //         const minutes = input.slice(2);  // Get remaining digits as minutes
    //         setTime(`${hours}:${minutes}`);  // Set time with colon
    //         const updateData = { ...formData, travel_time: `${hours}:${minutes}` }
    //         setFormData(updateData);
    //     } else {
    //         setTime(input); // Otherwise, just set the time as user types
    //         const updateData = { ...formData, travel_time: '00:00' }
    //         setFormData(updateData);
    //     }
    // };
    const handleTimeChange = (e) => {
        let input = e.target.value;
        if (input <= 0) {
            input = 0;
        }
        setTime(input);
        const updateData = { ...formData, travel_time: input }
        setFormData(updateData);

    }

    // Dynamically generate the placeholder based on current input
    // const generatePlaceholder = () => {
    //     if (time.length >= 2) return '00:00'; // After 2 digits, show placeholder for minutes
    //     return '00:00'; // Otherwise, only show placeholder for hours
    // };

    // Search Start
    const [searchData, setSearchData] = useState({ search_area: '', o_id: '' });
    const [searchItems, setSearchItems] = useState({});

    const clearSearch = () => {
        setSearchData({ search_area: '', o_id: '' })
    }
    const handleSearchChange = (event) => {
        const { name, value } = event.target;
        setSearchData(prevData => ({
            ...prevData,
            [name]: value,
            ...(name === 'search_area' && { o_id: '', tr_date: '' }), // Reset `o_id` if `search_area` changes
        }));
        if (name === 'tr_date' && value) {
            fetchSearchList(value)
        } if (name === 'search_area' && value === 'awb_manager') {
            fetchSearchList('', 'awb_manager');
        }
    }
    const fetchSearchList = async (dta, tn) => {
        const payload = { tab_name: tn ?? searchData.search_area, date: dta }
        try {
            const res = await withRFSToken.post('rfs-filter', payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (tn) {
                        setSearchItems({ ...searchItems, awbList: innerData ?? [] });
                    } else {
                        setSearchItems({ ...searchItems, truckList: innerData ?? [] });
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleSearch = async () => {
        if (searchData.search_area === 'booking_truck') {
            localStorage.removeItem('BTDetails');
            const dataToSend = { bookingtruck_date_id: searchData?.o_id, date: searchData?.tr_date, bookingtruck_id: searchData.bookingtruck_id }
            localStorage.setItem('BTDetails', JSON.stringify(dataToSend));
            window.location.href = '/BookingtruckDetails'
        } else if (searchData.search_area === 'truck_order') {
            localStorage.removeItem('TODetails');
            const storageData = { truck_orders_id: searchData.o_id, tab: 'shipment' };
            localStorage.setItem('TODetails', JSON.stringify(storageData));
            window.location.href = '/TruckOrderDetails'
        } else {
            localStorage.removeItem('OVDetails');
            const storageData = {
                ULD: {awb_no: searchData.o_label.trim(' '), awb_id: searchData.o_id},
                Left: {},
                sec: 'D',
                Back: {url: '/BookingtruckSchedule', tab: ''}
            };
            localStorage.setItem('OVDetails', JSON.stringify(storageData));
            // localStorage.setItem('tab', 'assets');
            // window.location.href = '/TruckMonitor/OrdersViewDetails'
            window.location.href = '/TruckMonitor/Details'
        }
    }
    // Search End

    return (
        <div className="">
            <Header logo_url='/BookingtruckSchedule' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab position-relative">
                        <TopMenu module='RFS' />
                        <div className='view_filter' style={{ position: 'absolute', top: '12px', right: '0' }}>
                            <Dropdown onToggle={(isOpen) => { if (!isOpen) { clearSearch(); } }}>
                                <Dropdown.Toggle variant="link" id="dropdown-basic" >
                                    <FontAwesomeIcon icon={faMagnifyingGlass} /> Search
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='filter_menu charter_from'>
                                    <div className='d-flex justify-content-between filter_text'><h3>Search </h3>  <Link to='#' onClick={clearSearch}>Clear</Link></div>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-1">
                                                <Form.Label>Search Area</Form.Label>
                                                <Form.Select aria-label="Default select example" value={searchData.search_area} name='search_area' onChange={handleSearchChange}>
                                                    <option value=''>Select</option>
                                                    <option value="awb_manager">AWB No.</option>
                                                    <option value="booking_truck">Scheduled Truck</option>
                                                    {/* <option value="truck_order">Operational Truck</option> */}
                                                </Form.Select>

                                            </Form.Group>
                                        </Col>
                                        <Col>

                                        </Col>
                                    </Row>
                                    {searchData.search_area &&
                                        <Row>
                                            {searchData.search_area == 'awb_manager' ?
                                                <Col>
                                                    <Form.Group className="mb-1">
                                                        <Form.Label>Select AWB Number</Form.Label>
                                                        {/* <Form.Control type="text" onChange={handleSearchChange} /> */}
                                                        <Select
                                                            options={searchItems.awbList || []}
                                                            placeholder="Select number"
                                                            className='down_selct'
                                                            onChange={(selected) => {
                                                                setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label });
                                                            }}
                                                            // isMulti
                                                            // name="status"
                                                            value={searchItems.awbList?.find(value => value.label === searchData.o_label) || ''}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                :
                                                <>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label>Truck Date</Form.Label>
                                                            <Form.Control type="date" name='tr_date' onChange={handleSearchChange} value={searchData.tr_date} />
                                                        </Form.Group>
                                                    </Col>
                                                    {searchData.tr_date &&
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-1">
                                                                <Form.Label>{searchData.search_area == 'booking_truck' ? 'Scheduled' : 'Operational'} Truck No.</Form.Label>
                                                                {/* <Form.Control type="text" onChange={handleSearchChange} /> */}
                                                                <Select
                                                                    options={searchItems.truckList || []}
                                                                    placeholder="Select number"
                                                                    className='down_selct'
                                                                    onChange={(selected) => {
                                                                        if (searchData.search_area == 'booking_truck') {
                                                                            setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label, bookingtruck_id: selected.bookingtruck_id });
                                                                        } else {
                                                                            setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label, });
                                                                        }
                                                                    }}
                                                                    // isMulti
                                                                    // name="status"
                                                                    value={searchItems.truckList?.find(value => value.label === searchData.o_label) || ''}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    }

                                                </>
                                            }
                                        </Row>
                                    }
                                    <div className="mt-3 text-end"><Button variant="primary" className='adduld m-0' onClick={handleSearch}>Search</Button></div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="">
                            <div className="allcontent-fl">
                                {/* <div className='d-flex justify-content-between mb-3'>
                                    <div>
                                        <button className={selectedButton === 'export' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('export')}>
                                            <img src={selectedButton === 'export' ? Exportw : Export} /> <span>Export</span>
                                        </button>
                                        <button className={selectedButton === 'import' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('import')}>
                                            <img src={selectedButton === 'import' ? Exportw : Export} /> <span>Import</span>
                                        </button>
                                    </div>
                                    <div className='search'>
                                        <div className="form-group has-search">
                                            <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                            <input type="text" className="form-control" placeholder="Search" />
                                        </div>

                                    </div>
                                </div> */}
                                <div className="lcontent">
                                    <div className="mb-3 nestedtabs rounded">

                                        <div className='d-flex justify-content-between'>
                                            <div>
                                                <button className="addtruck" variant="primary" onClick={handleShow}>
                                                    <span> <FontAwesomeIcon icon={faPlus} /> Add Bookingtrucks</span>
                                                </button>
                                            </div>
                                            <div className='d-flex'></div>
                                            <div className='mvownload'></div>
                                            
                                        </div>
                                    </div>
                                    {/* {console.log('kkk', stationData)} */}
                                    {showAddStationAddress && <AddStationAddress reloadAddress={handleReloadAddress} stationId={stationData.value} onClose={handleCloseModal} />}
                                    {showAddStation && <AddStation reloadStation={handleReloadAddress} onClose={handleCloseModal} />}

                                    <Modal show={show} onHide={handleClose} centered className='addfrom book_sdl'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>{formData.add_edit == 'E' ? 'Edit' : 'Add'} Bookingtruck</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>

                                            <Form>
                                                {/* {['radio'].map((type) => ( */}
                                                {/* <div className="mb-2">
                                                    <Form.Check
                                                        inline
                                                        label="Export"
                                                        name="booking_type"
                                                        type='radio'
                                                        id='export'
                                                        value='E'
                                                        checked={formData.booking_type === 'E'}
                                                        onChange={handleFormOnchange}
                                                    />

                                                    <Form.Check
                                                        inline
                                                        label="Import"
                                                        value="I"
                                                        name="booking_type"
                                                        type='radio'
                                                        id='import'
                                                        checked={formData.booking_type === 'I'}
                                                        onChange={handleFormOnchange}
                                                    />
                                                </div> */}
                                                {/* ))} */}

                                                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                                                    <Form.Label>Bookingtruck No</Form.Label>
                                                    <Form.Control type="email" placeholder="#12134567" name='bookingtruck_no' value={formData.bookingtruck_no} onChange={handleFormOnchange} />
                                                </Form.Group>
                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="6">
                                                        <Form.Label>Boardpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("bp")}> + Add </Button></Form.Label>
                                                        {/* {console.log('rty', boardpoint)} */}
                                                        <div className='autosugg'>
                                                            <Select
                                                                options={boardPoint}
                                                                onChange={(selected) => {
                                                                    setSelectedBoardPointAddress(null)
                                                                    const selectedpoint = boardPoint.find(option => option.value === selected.value);
                                                                    setBoardPointAddress(selectedpoint ? selectedpoint.address.map(handler => ({
                                                                        value: handler.id,
                                                                        label: `${handler.handler_name} - ${handler.address_1}`
                                                                    })) : []);
                                                                    setSelectedBoardpoint(selected);
                                                                    const updatedData = { ...formData, boardpoint: selected.value, boardpoint_address: '' };
                                                                    setFormData(updatedData);
                                                                    // onFormDataChange2(updatedData);
                                                                }}
                                                                placeholder="Boardpoint"
                                                                className='autoslct'
                                                                name="boardpoint"
                                                                value={boardPoint.find(option => option.value === formData.boardpoint)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Form.Label>Boardpoint Address <Button className='raad_adrss' onClick={() => handleAddAddressClick('bp', selectedBoardpoint)}>+ Add</Button></Form.Label> {/* > */}
                                                        <Select
                                                            options={boardPointAddress}
                                                            onChange={(selected) => {
                                                                const updatedData = { ...formData, boardpoint_address: selected.value };
                                                                setSelectedBoardPointAddress(selected);
                                                                setFormData(updatedData);
                                                            }}
                                                            placeholder="Address"
                                                            className='autoslct rfslct'
                                                            name="boardpoint_address"
                                                            isDisabled={boardPointAddress.length > 0 ? false : true}
                                                            value={boardPointAddress.length > 0 && formData.boardpoint_address !== ''
                                                                ? boardPointAddress.find(option => option.value === formData.boardpoint_address)
                                                                : null}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <Form.Group as={Row} className="mb-2">
                                                    <Col sm="6">
                                                        <Form.Label>Offpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("op")}> + Add </Button></Form.Label>
                                                        {/* {console.log('rty', boardpoint)} */}
                                                        <div className='autosugg'>
                                                            <Select
                                                                options={offPoint}
                                                                onChange={(selected) => {
                                                                    setSelectedOffPointAddress(null);
                                                                    const selectedpoint = boardPoint.find(option => option.value === selected.value);
                                                                    setOffPointAddress(selectedpoint ? selectedpoint.address.map(handler => ({
                                                                        value: handler.id,
                                                                        label: `${handler.handler_name} - ${handler.address_1}`
                                                                    })) : []);
                                                                    setSelectedOffpointId(selected)
                                                                    const updatedData = { ...formData, offpoint: selected.value, offpoint_address: '' };
                                                                    setFormData(updatedData);
                                                                    // onFormDataChange2(updatedData);
                                                                }}
                                                                placeholder="Offpoint"
                                                                className='autoslct'
                                                                name="offpoint"
                                                                value={offPoint.find(option => option.value === formData.offpoint)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col sm="6">
                                                        <Form.Label>Offpoint Address  <Button className='raad_adrss' onClick={() => handleAddAddressClick('op', selectedOffpointId)}>+ Add</Button></Form.Label> {/* > */}
                                                        <Select
                                                            options={offPointAddress}
                                                            onChange={(selected) => {
                                                                const updatedData = { ...formData, offpoint_address: selected.value };
                                                                setSelectedOffPointAddress(selected);
                                                                setFormData(updatedData);
                                                            }}
                                                            placeholder="Address"
                                                            className='autoslct rfslct'
                                                            name="offpoint_address"
                                                            isDisabled={offPointAddress.length > 0 ? false : true}
                                                            value={offPointAddress.length > 0 && formData.offpoint_address !== ''
                                                                ? offPointAddress.find(option => option.value === formData.offpoint_address)
                                                                : null}
                                                        />
                                                    </Col>
                                                </Form.Group>
                                                <hr />

                                                {/* {['radio'].map((type) => ( */}
                                                <div className="mb-2">
                                                    <Form.Check
                                                        inline
                                                        label="One-Off"
                                                        name="trip_type"
                                                        type='radio'
                                                        id='one-off'
                                                        value={"O"}
                                                        checked={frequentBooking === 'O'}
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Frequent"
                                                        name="trip_type"
                                                        type='radio'
                                                        id='Frequent'
                                                        value="F"
                                                        checked={frequentBooking === 'F'}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                                {/* ))} */}

                                                {frequentBooking === 'O' && (
                                                    <>
                                                        <Form.Group as={Row} className='mb-2'>
                                                            <Col sm="6">
                                                                <Form.Label>Departure Date / Time</Form.Label>
                                                                <Form.Control type="datetime-local" name='departure_date_time' value={formData.departure_date_time} onChange={handleFormOnchange} />
                                                            </Col>
                                                            <Col sm="6">
                                                                <Form.Label>Arrival Date / Time</Form.Label>
                                                                <Form.Control type="datetime-local" name='arrival_date_time' value={formData.arrival_date_time} onChange={handleFormOnchange} />
                                                            </Col>
                                                            {/* <Col sm="6">
                                                                <Form.Label>Departure Time</Form.Label>
                                                                <Form.Control type="time" name='departure_time' value={formData.departure_time} onChange={handleFormOnchange} />
                                                            </Col> */}
                                                        </Form.Group>
                                                        <Form.Group as={Row}>

                                                            {/* <Col sm="6">
                                                                <Form.Label>Arrival Time</Form.Label>
                                                                <Form.Control type="time" name='arrival_time' value={formData.arrival_time} onChange={handleFormOnchange} />
                                                            </Col> */}
                                                            <Col sm="6">
                                                                <Form.Label>Travel Days</Form.Label>
                                                                {/* <Form.Control type="time" name='travel_time' value={formData.travel_time} onChange={handleFormOnchange} /> */}
                                                                <Form.Control
                                                                    type="number"
                                                                    name='travel_time'
                                                                    value={time}
                                                                    onChange={handleTimeChange}
                                                                    maxLength={5} // Limit length to 5 characters (HH:MM)
                                                                    placeholder='0'
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                    </>
                                                )}
                                                {frequentBooking === 'F' && (
                                                    <>
                                                        <Form.Label>Select Weekdays</Form.Label>

                                                        <ul className='freq_week mb-3'>
                                                            <li className={selected.includes(1) ? 'selected' : ''} onClick={() => handleClick(1)}>Mo</li>
                                                            <li className={selected.includes(2) ? 'selected' : ''} onClick={() => handleClick(2)}>Tu</li>
                                                            <li className={selected.includes(3) ? 'selected' : ''} onClick={() => handleClick(3)}>We</li>
                                                            <li className={selected.includes(4) ? 'selected' : ''} onClick={() => handleClick(4)}>Th</li>
                                                            <li className={selected.includes(5) ? 'selected' : ''} onClick={() => handleClick(5)}>Fr</li>
                                                            <li className={selected.includes(6) ? 'selected' : ''} onClick={() => handleClick(6)}>Sa</li>
                                                            <li className={selected.includes(0) ? 'selected' : ''} onClick={() => handleClick(0)}>Su</li>
                                                        </ul>

                                                        <Form.Group as={Row} className='mb-2'>
                                                            <Form.Label>Bookingtruck Start & End Date </Form.Label>
                                                            <Col sm="6">
                                                                <Form.Control type="date" name='start_date' value={formData.start_date} onChange={handleFormOnchange} />
                                                            </Col>

                                                            <Col sm="6">
                                                                <Form.Control type="date" name='end_date' value={formData.end_date} onChange={handleFormOnchange} />
                                                            </Col>
                                                        </Form.Group>

                                                        <Form.Group as={Row} className='mb-2'>

                                                            <Col sm="6">
                                                                <Form.Label>Departure Time</Form.Label>
                                                                <Form.Control type="time" name='departure_time' value={formData.departure_time} onChange={handleFormOnchange} />
                                                            </Col>
                                                            <Col sm="6">
                                                                <Form.Label>Arrival Time</Form.Label>
                                                                <Form.Control type="time" name='arrival_time' value={formData.arrival_time} onChange={handleFormOnchange} />
                                                            </Col>
                                                            <Col sm="6">
                                                                <Form.Label>Travel Days</Form.Label>
                                                                <Form.Control
                                                                    type="number"
                                                                    name='travel_time'
                                                                    value={time}
                                                                    onChange={handleTimeChange}
                                                                    maxLength={5} // Limit length to 5 characters (HH:MM)
                                                                    placeholder='0'
                                                                />

                                                            </Col>

                                                        </Form.Group>

                                                        {/* <Form.Group as={Row} >
                                                           
                                                            <Col sm="6">
                                                            <Form.Label>Arival Date</Form.Label>
                                                                <Form.Control type="date" name='arrival_date' value={formData.arrival_date} onChange={handleFormOnchange} />
                                                            </Col>
                                                            <Col sm="6">
                                                            <Form.Label>Arival Time</Form.Label>
                                                                <Form.Control type="time" name='arrival_time' value={formData.arrival_time} onChange={handleFormOnchange} />
                                                            </Col>
                                                        </Form.Group> */}
                                                    </>
                                                )}

                                            </Form>

                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="primary" onClick={handleAddBookingtruck}  >
                                                {formData.add_edit == 'E' ? 'Update' : 'Add'} Bookingtruck
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>

                                    {selectedButton === 'export' &&
                                        <>
                                            <ExportGrid onEdit={handleEdit} ref={childRef} updateGridData={exportGrid} />
                                            {/* <Tabs defaultActiveKey="incoming" id="nested" className="booking_tab" onSelect={handleTabSelect}>
                                                <Tab eventKey="incoming" title={<span>Active</span>}>
                                                    <ExportActive onEdit={handleEdit} ref={childRef} updateGridData={exportGrid} />
                                                </Tab>
                                                <Tab eventKey="trash" title={<span>Trash</span>}>
                                                    <ExportTrash onEdit={handleEdit} ref={childRef} updateGridData={exportGrid} />
                                                </Tab>
                                            </Tabs> */}
                                        </>
                                    }
                                    {selectedButton === 'import' &&
                                        <ImportGrid onEdit={handleEdit} ref={childRef} updateGridData={exportGrid} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookingtruckSchedule